<template>
  <div class="bind-newuser">
    <el-form
      :model="codeForm"
      :rules="codeRules"
      ref="codeForm"
      class="register-from"
       @submit.native.prevent
    >
      <el-form-item prop="phone">
        <el-input
          v-model="codeForm.phone"
          placeholder="请输入手机号"
          @focus="phoneInput"
          @input="phoneInput"
          :maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item prop="code" class="code-item">
        <el-input
          v-model="codeForm.code"
          placeholder="请输入验证码"
          @focus="clearVerify('codeForm', 'code')"
          @change="codeErr = false"
          :maxlength="6"
        ></el-input>
        <div :class=" [codeBtnVal=='获取验证码' ? 'get-code':'get-code2']"  @click="clickCode">{{ codeBtnVal }}</div>
      </el-form-item>
      <el-form-item prop="password" class="pwd-item">
        <el-input
          :type="passwordFlag"
          v-model="codeForm.password"
          placeholder="数字、字母、符号(_-@&=.)组合的8-18位新密码"
          @focus="clearVerify('codeForm', 'password')"
          :maxlength="18"
          autocomplete="new-password"
        ></el-input>
        <i
          :class="['open-pwd', passwordFlag == 'password' ? 'icon1' : 'icon2']"
          @click="openPwd()"
        ></i>
      </el-form-item>
    </el-form>
    <div class="btn" @click="register" @keyup.enter="(e)=>keyDown(e)">
      {{ registerName }}
    </div>

    <p>
      根据《中华人民共和国网络安全法》要求，使用互联网服务需要进<br />行身份信息验证。请绑定手机号验证，感谢你的支持和理解。
    </p>
  </div>
</template>

<script>
import {
  phoneRegist,
  getDynamicCode,
  valiAccount,
  bindAccount,
} from "@/../api";
import { zhugeTrack, jumpAfterLogin } from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
export default {
  name: "",
  props: ["referUrl"],
  data() {
    return {
      codeerrorMessage: "请输入正确验证码，连续输入错误，账号将被锁定",
      passwordFlag: "password",
      codeBtnVal: "获取验证码",
      codeErr: false,
      registerName: "绑定并登录",
      codeForm: {
        phone: "",
        code: "",
        password: "",
      },
      codeRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },

          { validator: this.phoneValidator },
        ],

        code: [
          { validator: this.codeValidator },
          { required: true, message: "请输入动态验证码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入动态验证码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入数字、字母、符号(_-@&=.)组合的8-18位新密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
            message: "必须为8-18位数字、字母、常用符号(_-@&=.)组合",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch:{
    "sliderResult":{
      handler(val){
        if(val){
          this.getCode(val)
        }
      },
      deep:true,
      immediate:true
    },
  },
  computed: {
    ...mapState(["isToastshow", "message", "manyloginToast",'sliderResult']),
  },
   mounted(){
    window.addEventListener('keydown',this.keyDown)
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false)
  },
  methods: {
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow","isShowSliderVerifyHandle","sliderResultHandle"]),
     keyDown(e){
      if((e.keyCode==13||e.keyCode==100) ){
        this.register(e)
      }
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);
     
     const toastTimer= setTimeout(() => {
       this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    // 显示、隐藏密码
    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },

    // 账号是否已经注册
    phoneValidator(rule, value, callback) {
      if (this.phoneHas) {
        return callback(new Error("手机号已注册，请移步至「已有账号」绑定该账号！"));
      }else if(this.codeForm.phone.length != 11  || !(/^1\d{10}$/.test(this.codeForm.phone))){
        return callback(new Error("请填写正确手机号!"));
      } else {
        callback();
      }
    },

    // 动态验证码校验
    codeValidator(rule, value, callback) {
      if (this.codeErr) {
        return callback(new Error(this.codeerrorMessage));
      } else {
        callback();
      }
    },
    // 清除手机验证
    phoneFocus() {
      this.clearVerify("codeForm", "phone");
      this.phoneHas = false;
    },
    // 验证手机是否注册
    phoneInput() {
      this.phoneHas = false;
      this.$emit("setOldPhone",'')
      if (!this.codeForm.phone || this.codeForm.phone.length != 11  || !(/^1\d{10}$/.test(this.codeForm.phone))) {
        return;
      }
      let params = {
        username: this.codeForm.phone,
      };
      valiAccount(params).then((res) => {
        let data = res.data;
        if (data.resultObject == 400) {
          this.phoneHas = true;
         
          this.$emit("setOldPhone",this.codeForm.phone)
          this.$refs["codeForm"].validateField("phone");
        }else{
          this.clearVerify("codeForm", "phone");
          this.phoneHas = false;
        }
      });
    },
    //点击验证码
    clickCode(){
     
      if (this.codeBtnVal != "获取验证码") return;
      if (
        (!this.codeForm.phone ||
        this.codeForm.phone.length < 11 ||
        this.codeForm.phone[0] != 1) ||
        this.phoneHas == true
      ) {
        this.$refs["codeForm"].validateField("phone");
        return;
      }
      localStorage.setItem('currUserPhone', this.codeForm.phone)
      this.isShowSliderVerifyHandle(true)
    },
    // 获取验证码
    getCode(validCode) {
     
      let _this = this;
      let params = {
        mobileOrEmail: this.codeForm.phone.trim(),
        vType: 1,
        messageType: 1,
        validCode: validCode
      };
      this.codeBtnVal = "发送中...";
      this.sliderResultHandle(false)//清空拼图操作结果
      getDynamicCode(params).then((res) => {
        let data = res.data;
        if (data.success) {
          // 获取验证码成功
          let num = 60;
          var timer = setInterval(() => {
            if (num <= 0) {
              _this.codeBtnVal = "获取验证码";
              clearInterval(timer);
            } else {
              _this.codeBtnVal = num-- + "s";
            }
          }, 1000);
        } else {
          this.codeerrorMessage = data.developerMsg;
          this.codeErr = true;
          this.$refs["codeForm"].validateField("code");
          this.codeBtnVal = "获取验证码";
        }
      });
    },
    // 注册验证码登录
    register() {
      if (this.registerName != "绑定并登录") {
        return;
      }
     
      this.$refs["codeForm"].validate((valid) => {
        if (valid) {
          let did = zhuge.getDid();
          let sid = zhuge.getSid();
          let params = {
            username: this.codeForm.phone,
            password: this.codeForm.password,
            code: this.codeForm.code,
            registType: 2,
            additional: did + "@" + sid,
          };
          this.registerName = "绑定中...";
          let type=''
          if(window.location.search.indexOf('match')>-1){
              type='competition'
          }
          phoneRegist(params,type).then((res) => {
            let data = res.data;
            if (data.status == 200) {
              localStorage.removeItem(this.codeForm.phone);
              let bindParams = {
                account: this.codeForm.phone,
                password: this.codeForm.password,
                additional: did + "@" + sid,
                rememberme: "1",
                wechatLoginVo: this.$route.query,
              };
              bindAccount(bindParams).then((res) => {
                if (res.data.code == 200) {
                  // // 注册成功后登录
                  // let loginParams = {
                  //   username: this.codeForm.phone,
                  //   password: this.codeForm.password,
                  //   additional: did + "@" + sid,
                  //   remeberme: this.remeberme,
                  // };
                  // this.registerName = "绑定中...";
                  // userLogin(loginParams).then((res) => {
                 
                  //   let result = res.data;
                  //   if (result.data.code == 200) {
                  //     // 登录成功后的跳转
                  // jumpAfterLogin(this.referUrl);
                  //   } else {
                  //     this.show("绑定失败");
                  //     comPop(result.errorMessage);
                  //   }
                  jumpAfterLogin(this.referUrl);
                  this.registerName = "绑定并登录";
                  // });
                  zhugeTrack("Web_绑定并登录成功");
                } else if (res.data.code == 423) {
                  this.manyLoginToastshow();
                  this.registerName = "绑定并登录";
                } else if (res.data.code == 10000) {
                  this.show(res.data.developerMsg);
                  this.registerName = "绑定并登录";
                } else {
                  this.show("绑定失败");
                  this.registerName = "绑定并登录";
                }
              });
            } else if (data.status == 401) {
              //注册失败
              //存储当前用户的错误次数
              this.codeErr = true;
              this.codeerrorMessage =
                "请输入正确验证码，连续输入错误，账号将被锁定";
              this.$refs["codeForm"].validateField("code");
              
              this.registerName = "绑定并登录";
            } else if (data.status == 423) {
              this.manyLoginToastshow();
              this.registerName = "绑定并登录";
            } else {
              this.show("绑定失败");
              this.registerName = "绑定并登录";
            }
          });
          zhugeTrack("Web_点击绑定新账号");
        }
      });
    },
    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.bind-newuser {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  align-content: flex-start;
  .code-item {
    position: relative;
    ::v-deep .el-form-item__content {
      display: flex;
    }
    ::v-deep .el-input {
      display: flex;
      width: 240px;
      .el-input__inner {
        width: 240px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        border: 1px solid #e5e6eb;
        overflow: hidden;
      }
    }
    .get-code {
      width: 112px;
      height: 40px;
      background: #e8f3ff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      text-align: center;
      margin-left: 16px;
      cursor: pointer;
      &:hover {
        color: #165dff;
      }
    }
     .get-code2 {
      width: 112px;
      height: 40px;
      background: #e8f3ff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      text-align: center;
      margin-left: 16px;
     
    }
  }
  .pwd-item {
    position: relative;

    .open-pwd {
      width: 14px;
      height: 14px;
      position: absolute;
      cursor: pointer;
      top: 50%;
      right: 19px;
      transform: translateY(-50%);
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
      i {
        line-height: 14px;
      }
    }
    .icon1 {
      background: url("../../assets/login/icon／preview-close\(2\).png");
      background-size: 100% 100%;
      opacity: 1;
      width: 16px;
      height: 16px;
      background-size: cover;
    }
    .icon2 {
      background: url("../../assets/login/icon／preview-open.png");
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      background-size: cover;
      opacity: 1;
    }
  }

  .btn {
    width: 368px;
    height: 44px;
    border-radius: 4px;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 0;
    cursor: pointer;
    border: none;
    outline: none;
    text-align: center;
    line-height: 44px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background-color: #4080ff;
    }
  }
  .disabled {
    background: #ccc !important;
    cursor: auto;
    &:hover {
      background: #ccc !important;
    }
  }
  p {
    height: 40px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 20px;
    position: relative;
    padding-left: 8px;
    margin-top: 16px;
    &::before {
      content: "*";
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
      position: absolute;
      top: 0;
      left: -5px;
    }
  }
}
</style>
